const SPECIAL_CHARACTERS = "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~";


export const PASSWORD_REQUIREMENTS = [
  { key: "length", label: "Minimal 8 karakter", test: (value) => value.length >= 8 },
  { key: "uppercase", label: "Mengandung huruf besar", test: (value) => /[A-Z]/.test(value) },
  { key: "lowercase", label: "Mengandung huruf kecil", test: (value) => /[a-z]/.test(value) },
  { key: "number", label: "Mengandung angka", test: (value) => /\d/.test(value) },
  { key: "special", label: "Mengandung karakter khusus", test: (value) => [...value].some((char) => SPECIAL_CHARACTERS.includes(char)) },
];

export function passwordRequirementResults(password) {
  return PASSWORD_REQUIREMENTS.map((requirement) => ({
    ...requirement,
    valid: requirement.test(password),
  }));
}

export function isStrongPassword(password) {
  return passwordRequirementResults(password).every((requirement) => requirement.valid);
}
